import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EncuestasComponent.css';

const STORAGE_KEY = 'redsys_pending_redirect';

export const savePendingRedsysRedirect = (payload) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

const loadPendingRedsysRedirect = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const PagoEncuestaRedirectComponent = () => {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [payload] = useState(() => loadPendingRedsysRedirect());

  useEffect(() => {
    if (!payload?.url || !payload?.fields?.Ds_MerchantParameters || !payload?.fields?.Ds_Signature) {
      navigate('/contestar-encuesta', { replace: true });
      return;
    }

    const timer = setTimeout(() => {
      formRef.current?.submit();
    }, 250);

    return () => clearTimeout(timer);
  }, [navigate, payload]);

  if (!payload?.url || !payload?.fields) {
    return null;
  }

  return (
    <div className="encuesta-component">
      <div className="redsys-frame-shell">
        <div className="redsys-frame-header">
          <h1 className="titulo-page">Pago seguro</h1>
        </div>

        <form ref={formRef} method="POST" action={payload.url} target="_self">
          {Object.entries(payload.fields).map(([key, value]) => (
            <input key={key} type="hidden" name={key} value={value} />
          ))}
        </form>

        <div className="redsys-loading-panel" aria-live="polite">
          <span>Abriendo pago seguro...</span>
        </div>
      </div>
    </div>
  );
};
